var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Main',{ref:"tableMain",attrs:{"height":_vm.height,"loading":_vm.loading,"tableData":_vm.tableData,"type":_vm.type}},[_c('Header',{ref:"tableHeader",attrs:{"slot":"header"},on:{"query":_vm.getData},slot:"header"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }